export default "__VITE_ASSET__CFer8JuU__"